<template lang="pug">
  .action-show-products-element
    b-card.mb-0.card-inactive.p-2(no-body)
      .bg-white
        fieldset(:disabled="disabled")
          .text-sm.text-success(v-if="isNew") Nuevo
          b-form-group(label="Buscar atributo:", label-size="sm", label-cols="auto", v-for="e_a in Element_Attributes", :key="e_a.element_attribute_id", v-if="e_a.name === 'object_search'", :id="`element_attribute_${e_a.element_attribute_id}`")
            vue-tribute(:options="tributeOpts")
              b-input-group(size="sm" )
                b-form-input(placeholder="Atributo", :value="e_a.value", @input="updateElementAttribute(e_a, $event)")
                b-input-group-append
                  b-button(variant="soft-danger", @click="$emit('destroy', element_id)")
                    trash-2-icon.icon-sm
</template>

<script>
import templateElementCommon from '@/helpers/template-element-common'
import _debounce from 'lodash.debounce'

export default {
  mixins: [templateElementCommon],
  data () {
    return {}
  },
  computed: {},
  methods: {},
  created () {
    this.updateElementAttribute = _debounce((element_attribute, value) => {
      let attribute = JSON.parse(JSON.stringify(element_attribute))
      attribute.value = value
      this.updateAttribute(this.block_id, this.template_id, this.element_id, attribute)
    }, 2000, {leading: false, trailing: true})

    this.updateElementAttributeNow = (element_attribute, value) => {
      let attribute = JSON.parse(JSON.stringify(element_attribute))
      attribute.value = value
      this.updateAttribute(this.block_id, this.template_id, this.element_id, attribute)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/colors.scss';

  .action-show-products-element {

    &:not(:last-child) {
      margin-bottom: 1rem;
    }

    .entity-element {
      &:not(:last-child) {
        margin-bottom: 1rem;
      }
    }
  }
</style>
